module.exports = __webpack_public_path__ + "static/media/original.660b71c0.webp";